(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tsc-bag-look-offer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bag-look-offer'))customElements.define('bag-look-offer',class extends HTMLElement{connectedCallback(){this.formWrap=this.nextElementSibling?.matches('product-form')?this.nextElementSibling:this.parentElement.querySelector('product-form');this.form=this.formWrap?.querySelector('form');this.button=this.form?.querySelector('[type="submit"]');this.buttonText=this.button?.querySelector('span');this.variants=JSON.parse(this.querySelector('[data-dress-variants]').textContent||'[]');if(!this.form||!this.button)return;this.addEventListener('change',()=>this.update());this.form.addEventListener('submit',e=>this.submit(e),true);this.update()}get choice(){return this.querySelector('input[name^="BagLook-"]:checked')}get needsDress(){return['pair','complete'].includes(this.choice?.value)}get dressVariant(){const values=[...this.querySelectorAll('[data-dress-option]')].map(x=>x.value);return this.variants.find(v=>v.available&&v.options.every((x,i)=>String(x)===values[i]))}update(){const values=[...this.querySelectorAll('[data-dress-option]')].map(x=>x.value);const summary=this.querySelector('[data-dress-summary]');if(summary)summary.textContent=values.join(' / ');const c=this.choice?.value||'single';this.buttonText.textContent=c==='single'?'Add to cart':c==='pair'?'ADD BAG + DRESS · SAVE $15':c==='finishing'?'ADD BAG + NECKLACE + EARRINGS · SAVE $15':'ADD COMPLETE LOOK · SAVE $20'}async submit(e){if((this.choice?.value||'single')==='single')return;e.preventDefault();e.stopImmediatePropagation();const bag=this.form.querySelector('[name="id"]')?.value;const mode=this.choice.value;const ids=[bag];if(this.needsDress){if(!this.dressVariant){this.error('Please choose an available dress color and size.');return}ids.push(this.dressVariant.id)}if(['finishing','complete'].includes(mode))ids.push(this.dataset.necklaceVariantId,this.dataset.earringsVariantId);this.button.disabled=true;try{const res=await fetch(routes.cart_add_url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:ids.map(id=>({id:Number(id),quantity:1}))})});if(!res.ok)throw new Error('Unable to add this set.');const code=this.choice.dataset.code;const root=window.Shopify?.routes?.root||'/';window.location.href=root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(routes.cart_url)}catch(err){this.error(err.message);this.button.disabled=false}}error(msg){const el=this.querySelector('.tsc-bag-look__error');el.textContent=msg;el.hidden=false}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tsc-buy-two-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-two-offer')) {
    customElements.define(
      'buy-two-offer',
      class BuyTwoOffer extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.productForm = this.nextElementSibling?.matches('product-form')
            ? this.nextElementSibling
            : this.parentElement?.querySelector('product-form');
          this.form = this.productForm?.querySelector('form');
          this.submitButton = this.productForm?.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton?.querySelector('span');
          this.secondItem = this.querySelector('[data-buy-two-second]');
          this.bagItem = this.querySelector('[data-buy-two-bag]');
          this.lookItem = this.querySelector('[data-buy-two-look]');
          this.detailsToggle = this.querySelector('[data-bundle-details-toggle]');
          this.detailsCollapsed = false;
          this.errorElement = this.querySelector('[data-buy-two-error]');
          this.variants = this.readVariants();
          this.storageKey = 'tsc-buy-two-' + this.dataset.productId;

          if (!this.form || !this.submitButton || !this.submitButtonText || !this.secondItem) return;

          this.singleDisabled = this.submitButton.disabled;
          this.restoreState();
          this.addEventListener('change', this.onChange.bind(this));
          this.detailsToggle?.addEventListener('click', this.onToggleDetails.bind(this));
          this.form.addEventListener('submit', this.onSubmit.bind(this), true);
          this.updateState();
        }

        readVariants() {
          try {
            return JSON.parse(this.querySelector('[data-buy-two-variants]')?.textContent || '[]');
          } catch (error) {
            return [];
          }
        }

        get mode() {
          return this.querySelector('input[name^="PurchaseOption-"]:checked')?.value || 'single';
        }

        get selectedPrimaryVariantId() {
          const inputValue = this.form?.querySelector('[name="id"]')?.value;
          if (inputValue) return inputValue;

          const picker = this.closest('.product__info-container')?.querySelector('variant-selects');
          const selectedOptions = Array.from(picker?.querySelectorAll('fieldset') || []).map(
            (fieldset) => fieldset.querySelector('input:checked')?.value
          );
          if (!selectedOptions.length || selectedOptions.some((value) => !value)) return null;

          return this.variants.find(
            (variant) =>
              variant.available &&
              variant.options.length === selectedOptions.length &&
              variant.options.every((option, index) => String(option) === selectedOptions[index])
          )?.id || null;
        }

        get selectedSecondVariant() {
          const selectedOptions = Array.from(this.querySelectorAll('[data-buy-two-option]')).map(
            (fieldset) => fieldset.querySelector('input:checked')?.value
          );

          if (selectedOptions.some((value) => !value)) return null;

          return this.variants.find(
            (variant) =>
              variant.options.length === selectedOptions.length &&
              variant.options.every((option, index) => String(option) === selectedOptions[index])
          );
        }

        get selectedBagOption() {
          return this.querySelector('input[name^="BagOption-"]:checked');
        }

        get selectedLookOption() {
          return this.querySelector('[data-shawl-select]');
        }

        get selectedLookVariantIds() {
          return [this.selectedLookOption?.value].filter(Boolean);
        }

        onChange(event) {
          this.hideError();
          if (event.target?.name?.startsWith('PurchaseOption-')) this.detailsCollapsed = false;
          this.saveState();
          this.updateState();
        }

        onToggleDetails() {
          this.detailsCollapsed = !this.detailsCollapsed;
          this.updateState();
        }

        updateBagPreview() {
          const option = this.selectedBagOption;
          const image = this.querySelector('[data-bag-preview]');
          if (!option?.dataset.imageUrl || !image) return;
          image.src = option.dataset.imageUrl;
          image.srcset = '';
          image.alt = option.dataset.imageAlt || 'Suede-Effect Metal Handle Bag';
        }

        updateShawlPreview() {
          const option = this.selectedLookOption?.selectedOptions?.[0];
          const image = this.querySelector('[data-shawl-preview]');
          if (!option?.dataset.imageUrl || !image) return;
          image.src = option.dataset.imageUrl;
          image.srcset = '';
          image.alt = option.dataset.imageAlt || 'Soft Knit Triangle Shawl';
        }

        updateState() {
          const isBundle = this.mode === 'bundle';
          const isBag = this.mode === 'bag';
          const isLook = this.mode === 'look';
          const hasDetails = isBundle || isBag || isLook;
          if (isBag) this.updateBagPreview();
          if (isLook) this.updateShawlPreview();
          this.secondItem.hidden = !isBundle || this.detailsCollapsed;
          if (this.bagItem) this.bagItem.hidden = !isBag || this.detailsCollapsed;
          if (this.lookItem) this.lookItem.hidden = !isLook || this.detailsCollapsed;
          if (this.detailsToggle) {
            this.detailsToggle.hidden = !hasDetails;
            this.detailsToggle.setAttribute('aria-expanded', String(!this.detailsCollapsed));
            this.detailsToggle.textContent = this.detailsCollapsed ? 'Show bundle options' : 'Hide bundle options';
          }
          if (!isBundle && !isBag && !isLook) {
            this.submitButton.disabled = this.singleDisabled;
            this.submitButton.toggleAttribute('aria-disabled', this.singleDisabled);
            this.submitButtonText.textContent = this.dataset.singleLabel;
            return;
          }

          const primaryInput = this.form.querySelector('[name="id"]');

          if (isBag) {
            const bagOption = this.selectedBagOption;
            const unavailable = !this.selectedPrimaryVariantId || primaryInput?.disabled || !bagOption?.value;
            this.submitButton.disabled = unavailable;
            this.submitButton.toggleAttribute('aria-disabled', unavailable);
            this.submitButtonText.textContent = unavailable ? this.dataset.unavailableLabel : this.dataset.bagLabel;
            return;
          }

          if (isLook) {
            const lookOption = this.selectedLookOption;
            const lookVariantIds = this.selectedLookVariantIds;
            const unavailable =
              !this.selectedPrimaryVariantId ||
              primaryInput?.disabled ||
              !lookOption ||
              lookVariantIds.length === 0;
            this.submitButton.disabled = unavailable;
            this.submitButton.toggleAttribute('aria-disabled', unavailable);
            this.submitButtonText.textContent = unavailable
              ? this.dataset.unavailableLabel
              : lookOption.dataset.addLabel || this.dataset.lookLabel;
            return;
          }

          const secondVariant = this.selectedSecondVariant;
          const unavailable = !this.selectedPrimaryVariantId || primaryInput?.disabled || !secondVariant?.available;

          this.submitButton.disabled = unavailable;
          this.submitButton.toggleAttribute('aria-disabled', unavailable);
          this.submitButtonText.textContent = unavailable ? this.dataset.unavailableLabel : this.dataset.addTwoLabel;
        }

        saveState() {
          try {
            const options = Array.from(this.querySelectorAll('[data-buy-two-option]')).map(
              (fieldset) => fieldset.querySelector('input:checked')?.value
            );
            sessionStorage.setItem(
              this.storageKey,
              JSON.stringify({
                mode: this.mode,
                options: options,
                lookOption: this.selectedLookOption?.value || null,
                bagOption: this.selectedBagOption?.value || null
              })
            );
          } catch (error) {
            return;
          }
        }

        restoreState() {
          try {
            const state = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
            if (!state) return;

            const modeInput = Array.from(this.querySelectorAll('input[name^="PurchaseOption-"]')).find(
              (input) => input.value === state.mode
            );
            if (modeInput) modeInput.checked = true;

            this.querySelectorAll('[data-buy-two-option]').forEach((fieldset, index) => {
              const optionInput = Array.from(fieldset.querySelectorAll('input')).find(
                (input) => input.value === state.options?.[index]
              );
              if (optionInput) optionInput.checked = true;
            });

            if (state.bagOption) {
              const bagInput = Array.from(this.querySelectorAll('input[name^="BagOption-"]')).find((input) => input.value === state.bagOption);
              if (bagInput) bagInput.checked = true;
            }

            if (state.lookOption && this.selectedLookOption) {
              this.selectedLookOption.value = state.lookOption;
            }
          } catch (error) {
            return;
          }
        }

        onSubmit(event) {
          if (this.mode !== 'bundle' && this.mode !== 'bag' && this.mode !== 'look') return;

          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.isAdding) return;
          this.addBundle();
        }

        buildItems(firstVariantId, ...additionalVariantIds) {
          const quantities = new Map();

          [firstVariantId, ...additionalVariantIds].forEach((id) => {
            quantities.set(id, (quantities.get(id) || 0) + 1);
          });

          return Array.from(quantities, ([id, quantity]) => ({ id: Number(id), quantity: quantity }));
        }

        startLinesUpdate(items) {
          const CartLinesUpdateEvent = window.StandardEvents?.CartLinesUpdateEvent;
          if (!CartLinesUpdateEvent) return null;

          const deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map((item) => ({
                merchandiseId: String(item.id),
                quantity: item.quantity
              })),
              promise: deferred.promise
            })
          );
          return deferred;
        }

        async resolveLinesUpdate(deferred) {
          if (!deferred) return;
          const CartLinesUpdateEvent = window.StandardEvents?.CartLinesUpdateEvent;
          if (!CartLinesUpdateEvent) return;

          try {
            const response = await fetch(routes.cart_url + '.json');
            const cart = await response.json();
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          } catch (error) {
            deferred.reject(error);
          }
        }

        async getRenderedSections(sectionIds, fallbackSections) {
          if (!sectionIds.length) return fallbackSections || {};

          try {
            const response = await fetch(
              routes.cart_url + '?sections=' + encodeURIComponent(sectionIds.join(','))
            );
            if (!response.ok) throw new Error('Unable to refresh cart sections');

            const renderedSections = await response.json();
            if (sectionIds.every((sectionId) => renderedSections[sectionId])) {
              return renderedSections;
            }
          } catch (error) {
            return fallbackSections || {};
          }

          return fallbackSections || {};
        }

        async addBundle() {
          const firstVariantId = this.selectedPrimaryVariantId;
          const isLook = this.mode === 'look';
          const isBag = this.mode === 'bag';
          const secondVariant = isLook || isBag ? null : this.selectedSecondVariant;
          const additionalVariantIds = isLook
            ? this.selectedLookVariantIds
            : isBag ? [this.selectedBagOption?.value].filter(Boolean) : [secondVariant?.id].filter(Boolean);
          const additionalItemsAvailable = isLook || isBag ? additionalVariantIds.length > 0 : secondVariant?.available;

          if (!firstVariantId || !additionalItemsAvailable || additionalVariantIds.length === 0) {
            this.showError(this.dataset.errorLabel);
            this.updateState();
            return;
          }

          const items = this.buildItems(firstVariantId, ...additionalVariantIds);
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections = cart?.getSectionsToRender().map((section) => section.id) || [];
          const payload = { items: items };

          if (sections.length) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          const deferred = this.startLinesUpdate(items);
          this.isAdding = true;
          this.setLoading(true);

          try {
            const response = await fetch(routes.cart_add_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(payload)
            });
            const data = await response.json();

            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || this.dataset.errorLabel);
            }

            await this.resolveLinesUpdate(deferred);

            if (isBag || isLook) {
              const root = window.Shopify?.routes?.root || '/';
              const codes = isBag
                ? 'TSC-BAG-DRESS-15'
                : 'TSC-DRESS-SHAWL-10,TSC-BUNDLE-FS-7H4Q2';
              window.location.href =
                root + 'discount/' + encodeURIComponent(codes) + '?redirect=' + encodeURIComponent(routes.cart_url);
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'buy-two-offer',
                productVariantId: String(firstVariantId),
                cartData: data
              });
            }

            if (cart) {
              const renderedSections = await this.getRenderedSections(sections, data.sections);
              const hasCompleteCartSections = sections.every(
                (sectionId) => renderedSections[sectionId]
              );

              if (hasCompleteCartSections) {
                cart.classList.remove('is-empty');
                cart.renderContents({
                  id: Number(additionalVariantIds[additionalVariantIds.length - 1]),
                  sections: renderedSections
                });
              } else {
                window.location = routes.cart_url;
              }
            } else {
              window.location = routes.cart_url;
            }
          } catch (error) {
            deferred?.reject(error);
            this.showError(error.message || this.dataset.errorLabel);
            const CartErrorEvent = window.StandardEvents?.CartErrorEvent;
            if (CartErrorEvent) {
              this.dispatchEvent(new CartErrorEvent({ error: error.message, code: 'INVALID' }));
            }
          } finally {
            this.isAdding = false;
            this.setLoading(false);
            this.updateState();
          }
        }

        setLoading(loading) {
          this.submitButton.classList.toggle('loading', loading);
          this.submitButton.toggleAttribute('aria-disabled', loading);
          this.submitButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
        }

        showError(message) {
          this.errorElement.textContent = message;
          this.errorElement.hidden = false;
        }

        hideError() {
          this.errorElement.hidden = true;
          this.errorElement.textContent = '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tsc-coat-shawl-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coat-shawl-offer')) {
    customElements.define(
      'coat-shawl-offer',
      class CoatShawlOffer extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.productForm = this.nextElementSibling?.matches('product-form')
            ? this.nextElementSibling
            : this.parentElement?.querySelector('product-form');
          this.form = this.productForm?.querySelector('form');
          this.submitButton = this.productForm?.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton?.querySelector('span');
          this.details = this.querySelector('[data-coat-shawl-details]');
          this.shawlSelect = this.querySelector('[data-shawl-select]');
          this.errorElement = this.querySelector('[data-coat-shawl-error]');

          if (!this.form || !this.submitButton || !this.submitButtonText || !this.shawlSelect) return;

          this.addEventListener('change', this.onChange.bind(this));
          this.form.addEventListener('submit', this.onSubmit.bind(this), true);
          this.updateState(false);
        }

        get mode() {
          return this.querySelector('input[name^="CoatPurchaseOption-"]:checked')?.value || 'single';
        }

        get primaryVariantId() {
          return this.form?.querySelector('[name="id"]')?.value || null;
        }

        onChange(event) {
          this.hideError();
          if (event.target === this.shawlSelect) this.updatePreview();
          this.updateState(event.target?.name?.startsWith('CoatPurchaseOption-'));
        }

        updatePreview() {
          const option = this.shawlSelect.selectedOptions?.[0];
          const image = this.querySelector('[data-shawl-preview]');
          if (!option?.dataset.imageUrl || !image) return;
          image.src = option.dataset.imageUrl;
          image.srcset = '';
          image.alt = option.dataset.imageAlt || 'Soft Knit Triangle Shawl';
        }

        updateState(openDetails) {
          const isBundle = this.mode === 'bundle';
          this.details.hidden = !isBundle;
          if (isBundle && openDetails) this.details.open = true;
          if (!isBundle) this.details.open = false;

          if (isBundle) {
            const unavailable = !this.primaryVariantId || !this.shawlSelect.value;
            this.submitButton.disabled = unavailable;
            this.submitButton.toggleAttribute('aria-disabled', unavailable);
            this.submitButtonText.textContent = unavailable ? this.dataset.unavailableLabel : this.dataset.bundleLabel;
          } else {
            this.submitButtonText.textContent = this.dataset.singleLabel;
          }
        }

        onSubmit(event) {
          if (this.mode !== 'bundle') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.isAdding) return;
          this.addBundle();
        }

        startLinesUpdate(items) {
          const CartLinesUpdateEvent = window.StandardEvents?.CartLinesUpdateEvent;
          if (!CartLinesUpdateEvent) return null;
          const deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
              promise: deferred.promise
            })
          );
          return deferred;
        }

        async resolveLinesUpdate(deferred) {
          if (!deferred) return;
          const CartLinesUpdateEvent = window.StandardEvents?.CartLinesUpdateEvent;
          if (!CartLinesUpdateEvent) return;
          try {
            const response = await fetch(routes.cart_url + '.json');
            const cart = await response.json();
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          } catch (error) {
            deferred.reject(error);
          }
        }

        async addBundle() {
          const coatVariantId = this.primaryVariantId;
          const shawlVariantId = this.shawlSelect.value;
          if (!coatVariantId || !shawlVariantId) {
            this.showError(this.dataset.errorLabel);
            return;
          }

          const items = [
            { id: Number(coatVariantId), quantity: 1 },
            { id: Number(shawlVariantId), quantity: 1 }
          ];
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections = cart?.getSectionsToRender?.().map((section) => section.id) || [];
          const payload = { items: items };
          if (sections.length) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
            cart.setActiveElement?.(document.activeElement);
          }

          const deferred = this.startLinesUpdate(items);
          this.isAdding = true;
          this.setLoading(true);

          try {
            const response = await fetch(routes.cart_add_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);

            await this.resolveLinesUpdate(deferred);

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'coat-shawl-offer',
                productVariantId: String(coatVariantId),
                cartData: data
              });
            }

            if (cart && sections.length && sections.every((sectionId) => data.sections?.[sectionId])) {
              cart.classList.remove('is-empty');
              cart.renderContents({
                id: Number(shawlVariantId),
                sections: data.sections
              });
            } else {
              window.location = routes.cart_url;
            }
          } catch (error) {
            deferred?.reject(error);
            this.showError(error.message || this.dataset.errorLabel);
          } finally {
            this.isAdding = false;
            this.setLoading(false);
            this.updateState(false);
          }
        }

        setLoading(loading) {
          this.submitButton.classList.toggle('loading', loading);
          this.submitButton.toggleAttribute('aria-disabled', loading);
          this.submitButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
        }

        showError(message) {
          this.errorElement.textContent = message;
          this.errorElement.hidden = false;
        }

        hideError() {
          this.errorElement.hidden = true;
          this.errorElement.textContent = '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
